import mediaQueries from "./media-queries";

const container = {
  display: "flex",
  width: "1024px",
  alignSelf: "flex-end",
  marginTop: "200px",
  [mediaQueries.desktop]: {
    marginTop: 0,
    alignSelf: "center",
  }
};

const wrapper = {
  background: "#ffffff",
  flexBasis: "100%",
  justifyContent: "center",
  flexWrap: "wrap",
  maxWidth: "100%",
  padding: "23px 30px 30px",
  [mediaQueries.desktop]: {
    maxWidth: "440px",
    padding: "45px 60px",
  }
};

const title = {
  fontFamily: "JWSansBold",
  fontWeight: "normal",
  color: "#000000",
  textAlign: "center",
  textTransform: "uppercase",
  margin: 0,
  fontSize: "18px",
  lineHeight: "30px",
  letterSpacing: "3.5px",
  [mediaQueries.tablet]: {
    fontSize: "20px",
    letterSpacing: "3.5px",
    lineHeight: "26px"
  }
};

const product = {
  ...title,
  marginBottom: "20px",
  fontSize: "30px",
  lineHeight: "36px",
  letterSpacing: "7px",
  [mediaQueries.tablet]: {
    fontSize: "38px",
    lineHeight: "48px",
    letterSpacing: "6.33px",
  }
};

const separator = {
  fontFamily: "JWSansBook",
  color: "#000000",
  margin: "15px 0",
  textAlign: "center",
  width: "100%",
  fontSize: "16px",
  letterSpacing: "0.6px",
  lineHeight: "16px",
  [mediaQueries.tablet]: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    lineHeight: "24px"
  }
};

const videoActive = {
  display: "none",
  [mediaQueries.tablet]: {
    display: "block"
  }
};

const disclaimer = {
  fontFamily: "JWSansBook",
  color: "#000000",
  zIndex: 1,
  textAlign: "center",
  clear: "both",
  margin: 0,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.45px"
};

const disclaimerTop = {
  ...disclaimer,
}

const warning = {
  ...disclaimer,
};

const terms = {
  marginTop: "12px"
};

export default {
  container,
  wrapper,
  title,
  product,
  separator,
  videoActive,
  disclaimer,
  disclaimerTop,
  warning,
  terms
};



// WEBPACK FOOTER //
// ./src/styles/landing.js